/* ---------------------------------------------------------------------------------------------------------------------
   APOLOSIGN CUSTOM SCRIPTS
   ---------------------------------------------------------------------------------------------------------------------
   Store-specific behavior overrides. Companion to apolosign_custom.css.
--------------------------------------------------------------------------------------------------------------------- */

/* The theme's rating link points at #shopify-product-reviews, which doesn't exist with
   LAI Reviews. Scroll to the LAI reviews section instead, matched by the stable part of
   its per-page-hashed id. (Can't forward the click to LAI's own star block: those are
   being removed from the templates in favor of the theme rating.) */
document.addEventListener('click', (event) => {
  if (!event.target.closest('a[href$="#shopify-product-reviews"]')) return;
  event.preventDefault();
  document.querySelector('[id*="lai_product_reviews_lai_product_section"]')?.scrollIntoView({ behavior: 'smooth' });
});
